module.exports = __webpack_public_path__ + "img/a1-s21.745b3a09.jpg";